import React, {Component} from 'react';
import '../../assets/css/tour.css';
import Banner from "../../widget/PageBanner";
import {Button} from 'semantic-ui-react';
import TourItinerary from "./TourItinerary.js";
import data from '../../assets/json/tours/tour-canadian-rockies.json';
import {Redirect} from 'react-router';

export default class TourCanadianRockies extends Component{
	constructor(props){
		super(props);
		this.state = {
			data: data.canadianrockies,
			redirect:false,
			routeLink: ''
		};
	}

	componentDidMount = () =>{
		window.scrollTo(0, 0);
	}

	redirectTourDetails = (id) => {
		this.setState({
			redirect: true,
			routeLink: id === 1 ? '/contactus' : id === 2 ? '/tours' : ''
		});
	}

	render(){
		let {redirect, routeLink, data} = this.state;
		return (
			<div>
				{ redirect && <Redirect push to={routeLink}/> }
				<div className="half-banner-wrapper">
					<Banner pagename="TourCanadianRockies"/>
				</div>

				<div className="section-content-wrapper margin-top-5">
					{
						data.map(
							(img, i) => (
								<TourItinerary
									key={i}
									portrait={img.portrait}
									landscape={img.landscape}
									day={img.day}
									utf={img.utf}
									itinerary={img.itinerary}
									highlights={img.highlights}
									inclusions={img.inclusions}
									fees={img.fees}
									exclusions={img.exclusions}
									hotel={img.hotel}
									biblicalref={img.biblicalref}
								/>
							)
						)
					}
				</div>
				<div className="section-content-wrapper margin-top-5 align-center">
					<Button color='orange' onClick={() => this.redirectTourDetails(1)}>Inquire now</Button>
					<Button color='orange' inverted onClick={() => this.redirectTourDetails(2)}>Check other tours</Button>
				</div>
			</div>
		);
	}
}
